import { Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-hint-icon',
  imports: [MatTooltip],
  templateUrl: './hint-icon.html',
})
export class HintIcon {
  text = input.required<string>();
}
